import * as React from 'react';
import { cn } from '@/lib/utils';

interface ErrorAlertProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: string | null;
}

/**
 * Reusable error alert component for displaying validation/API errors
 * Renders nothing if error is falsy
 */
export const ErrorAlert = React.forwardRef<HTMLDivElement, ErrorAlertProps>(
  ({ error, className, ...props }, ref) => {
    if (!error) return null;

    return (
      <div
        ref={ref}
        className={cn(
          'rounded-md bg-red-50 p-3 text-sm text-red-800 border border-red-200',
          className
        )}
        role="alert"
        {...props}
      >
        {error}
      </div>
    );
  }
);

ErrorAlert.displayName = 'ErrorAlert';
